  // matchHeight
  $(function() {
    $('.product--details--title, .featured__blog-container h3, .blog__grid h3').matchHeight();
  });

  // gift wrap
  (() => {
  let busy = false;

  const postJSON = (url, data) =>
    fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(data),
    }).then(async (r) => {
      const txt = await r.text();
      let json;
      try { json = JSON.parse(txt); } catch { json = { raw: txt }; }
      if (!r.ok) throw { status: r.status, body: json };
      return json;
    });

  async function getCart() {
    const r = await fetch("/cart.js", { credentials: "same-origin" });
    return r.json();
  }

  document.addEventListener(
    "change",
    async (e) => {
      const cb = e.target.closest(".js-giftwrap-toggle");
      if (!cb) return;

      const vid = Number(cb.dataset.giftVariantId || 0);
      if (!vid) return;

      if (busy) return;
      busy = true;

      try {
        const cart = await getCart();

        // cart.items の並び＝line (1始まり)
        const giftIndex = cart.items.findIndex((i) => i.variant_id === vid);
        const giftLine = giftIndex >= 0 ? giftIndex + 1 : null;

        if (cb.checked) {
          // 既に入ってたら何もしない
          if (giftLine === null) {
            await postJSON("/cart/add.js", { items: [{ id: vid, quantity: 1 }] });
          }
        } else {
          // 入ってたら line 指定で0にする（これが確実）
          if (giftLine !== null) {
            await postJSON("/cart/change.js", { line: giftLine, quantity: 0 });
          }
        }

        location.reload();
      } catch (err) {
        console.error("[giftwrap] error", err);
        alert(`ギフトラッピングの更新に失敗しました（${err?.status || "?"}）`);
        // UIを元に戻す（失敗時にチェック状態がズレるのを防ぐ）
        cb.checked = !cb.checked;
      } finally {
        busy = false;
      }
    },
    true
  );
})();

// datetime
(() => {
  const timeSel = document.getElementById('CartAttrTime');
  if (!timeSel) return;

  async function updateAttributes(attrs) {
    const res = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    });
    if (!res.ok) throw new Error('cart/update.js failed');
    return res.json();
  }

  function tryThemeRefresh() {
    // ありがちなイベント名を順番に投げる（テーマ依存）
    const names = [
      'cart:refresh',
      'cart:updated',
      'ajaxCart:refresh',
      'ajaxCart:updated'
    ];
    names.forEach((n) => document.dispatchEvent(new CustomEvent(n)));

    // それでも反映しないテーマ向け最終手段
    // （ページ全体をリロード＝確実に表示が揃う）
    setTimeout(() => {
      // “選択が戻らない”問題だけ解決したいならONにしてOK
      // location.reload();
    }, 150);
  }

  let lock = false;
  timeSel.addEventListener('change', async () => {
    if (lock) return;
    lock = true;

    const v = timeSel.value || ''; // ← 空＝「時間指定なし」に戻したら "" を送る

    try {
      await updateAttributes({ datetime: v });
      tryThemeRefresh();
    } catch (e) {
      console.error(e);
    } finally {
      lock = false;
    }
  });
})();

document.addEventListener('click', function (event) {
  const checkbox = event.target.closest('.js-keep-on-trying');
  if (!checkbox) return;

  const campaignText = 'KEEP ON TRYING';
  const isChecked = checkbox.checked;

  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      let note = cart.note || '';

      if (isChecked) {
        if (!note.includes(campaignText)) {
          note = note.trim() ? note.trim() + '\n' + campaignText : campaignText;
        }
      } else {
        note = note
          .replace(campaignText, '')
          .replace(/\n{2,}/g, '\n')
          .trim();
      }

      return fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ note: note })
      });
    })
    .then(response => {
      if (!response.ok) throw new Error('cart note update failed');
      window.location.href = window.location.href;
    })
    .catch(error => {
      console.error('KEEP ON TRYING note update error:', error);
    });
});